import { TimeFieldsContainer, TimeSelect } from "./style";

interface ITimeFieldsProps {
  date?: Date;
  value?: string;
  onChange?: (time: string) => void;
}

type Periodo = "AM" | "PM";

const HORAS = Array.from({ length: 12 }, (_, i) => String(i + 1));
const MINUTOS = Array.from({ length: 60 }, (_, i) => String(i).padStart(2, "0"));

function para12Horas(hora24: number): { hora: number; periodo: Periodo } {
  const periodo: Periodo = hora24 >= 12 ? "PM" : "AM";
  const hora = hora24 % 12 || 12;
  return { hora, periodo };
}

function para24Horas(hora12: number, periodo: Periodo): number {
  const hora24 = hora12 % 12;
  return periodo === "PM" ? hora24 + 12 : hora24;
}

export function TimeFields({ value, onChange }: ITimeFieldsProps) {
  const [horaStr, minuto] = (value ?? "00:00").split(":");
  const { hora, periodo } = para12Horas(Number(horaStr));

  const atualizar = (novaHora: number, novoMinuto: string, novoPeriodo: Periodo) => {
    const hora24 = String(para24Horas(novaHora, novoPeriodo)).padStart(2, "0");
    onChange?.(`${hora24}:${novoMinuto}`);
  };

  return (
    <TimeFieldsContainer>
      <TimeSelect
        value={hora}
        onChange={(e) => atualizar(Number(e.target.value), minuto, periodo)}
      >
        {HORAS.map((h) => (
          <option key={h} value={h}>
            {h}
          </option>
        ))}
      </TimeSelect>
      <TimeSelect
        value={minuto}
        onChange={(e) => atualizar(hora, e.target.value, periodo)}
      >
        {MINUTOS.map((m) => (
          <option key={m} value={m}>
            {m}
          </option>
        ))}
      </TimeSelect>
      <TimeSelect
        value={periodo}
        onChange={(e) => atualizar(hora, minuto, e.target.value as Periodo)}
      >
        <option value="AM">AM</option>
        <option value="PM">PM</option>
      </TimeSelect>
    </TimeFieldsContainer>
  );
}
